import { getParameterByName } from "./urlUtils";

export const setForceSentryDebug = () => {
    const query = "forceSentryDebug";
    const forceSentryDebugQParam = getParameterByName(query);

    if (forceSentryDebugQParam) {
        if (forceSentryDebugQParam === "true") {
            window.localStorage.setItem("forceSentryDebug", true);
        } else if (forceSentryDebugQParam === "false") {
            window.localStorage.removeItem("forceSentryDebug");
        }
    }
};
